import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.response.use(
  (response) => {
    // If Vercel rewrites the API call to index.html, it returns 200 OK with HTML content.
    // We must reject this so the app's catch blocks can handle it gracefully.
    // JSON starts with '{' or '[', HTML starts with '<'
    if (typeof response.data === 'string' && response.data.trim().startsWith('<')) {
      return Promise.reject(new Error('Received HTML fallback instead of JSON. Backend may not be deployed.'));
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
